export const customStyles = {
  option: (base, state) => ({
    ...base,
    color: !state?.isDisabled ? "#333536" : "#969696",
    backgroundColor: "#FFFFFF",
    ":active": {
      color: "#333536",
      backgroundColor: "#F6F7FD",
    },
    ":hover": {
      color: !state?.isDisabled ? "#3399FF" : "#969696",
      backgroundColor: "#F6F7FD",
    },
    padding: "0.5rem 1rem",
    fontWeight: 500,
    textOverflow: "ellipsis",
    cursor: "pointer",
    fontSize: "13px",
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: "0 0 0 0 transparent",
    borderColor: "#eff0f6",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#969696",
    fontWeight: 600,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#3399ff",
  }),
  valueContainer: (provided) => ({
    ...provided,
    color: "#3399FF",
    fontSize: "13px",
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "20px",
    background: "#eff0f6",
  }),
  indicatorsContainer: (provided, state) =>
    state.isMulti
      ? {
          ...provided,
          display: "none",
        }
      : { ...provided },
  dropdownIndicator: (base, state) => ({
    ...base,
    width: 30,
    color: state.isFocused ? "#333536" : "#CCCCCC",
  }),
  clearIndicator: (base) => ({
    ...base,
    width: 35,
  }),
};
